import moment from "moment";

export const EQUIPMENT_CATEGORY_FORM_TYPE_OPTIONS = [
  { label: "Text", value: "text" },
  { label: "Number", value: "number" },
  { label: "Boolean", value: "boolean" },
  { label: "Select", value: "select" },
  { label: "TextArea", value: "textarea" },
  { label: "Date", value: "date" },
];

export const createEmptyEquipmentCategoryForm = () => ({
  label: "",
  description: "",
  unit: "",
  formType: "text",
  extra: "",
  require: false,
});

export const parseEquipmentCategoryFormOptions = (raw) => {
  const options = [];
  const seen = new Set();
  String(raw || "")
    .split(/[,;]/)
    .map((option) => option.trim())
    .filter(Boolean)
    .forEach((option) => {
      if (!seen.has(option)) {
        seen.add(option);
        options.push(option);
      }
    });
  return options;
};

export const normalizeEquipmentCategoryForms = (forms) => {
  if (!Array.isArray(forms)) return [];
  return forms.map((row) => ({
    label: typeof row?.label === "string" ? row.label : "",
    description: typeof row?.description === "string" ? row.description : "",
    unit: typeof row?.unit === "string" ? row.unit : "",
    formType: EQUIPMENT_CATEGORY_FORM_TYPE_OPTIONS.some(
      (option) => option.value === row?.formType
    )
      ? row.formType
      : "text",
    extra: typeof row?.extra === "string" ? row.extra : "",
    require: row?.require === true,
  }));
};

export const normalizeEquipmentFormValuesForForm = (forms, values) => {
  const source = values && typeof values === "object" && !Array.isArray(values) ? values : {};
  const normalized = {};
  normalizeEquipmentCategoryForms(forms).forEach((definition) => {
    if (!Object.prototype.hasOwnProperty.call(source, definition.label)) {
      normalized[definition.label] = undefined;
      return;
    }
    const value = source[definition.label];
    normalized[definition.label] =
      definition.formType === "date" && value
        ? (moment.isMoment(value) ? value : moment(value, "YYYY-MM-DD", true))
        : value;
  });
  return normalized;
};

export const normalizeEquipmentFormValuesForSubmit = (forms, values) => {
  const source = values && typeof values === "object" && !Array.isArray(values) ? values : {};
  const normalized = {};
  normalizeEquipmentCategoryForms(forms).forEach((definition) => {
    if (!Object.prototype.hasOwnProperty.call(source, definition.label)) return;
    let value = source[definition.label];
    if (value === undefined || value === null || value === "") return;
    if (definition.formType === "date" && moment.isMoment(value)) {
      value = value.format("YYYY-MM-DD");
    }
    normalized[definition.label] = value;
  });
  return normalized;
};
